import styled from 'styled-components';

export default styled.div`
  width: 1063px;
  .table-header {
    width: 100%;
  }
  .public-modal-list {
    width: 100%;
    padding: 20px 32px 24px;
    .table-content {
      margin: 0;
    }
  }
  .modal-btn-wrap {
    display: flex;
    flex-direction: row;
    float: right;
    gap: 6px;
  }

  .public-search-wrap {
    /* width: 100%; */
    height: 40px;
    padding: 0 32px;
    display: flex;
    align-items: center;
    gap: 32px;
  }
  .template-name {
    width: 417px;
  }
  .template-sms-select {
    width: 155px;
    justify-content: end;
  }
`;
